'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

var useEscapeKeyListener = function useEscapeKeyListener(cb) {
  react.useEffect(function () {
    var checkEscapePressed = function checkEscapePressed(_ref) {
      var key = _ref.key;
      if (key === 'Escape' || key === 'Esc') {
        cb();
      }
    };
    document.addEventListener('keydown', checkEscapePressed);
    return function () {
      document.removeEventListener('keydown', checkEscapePressed);
    };
  }, []);
};

exports.useEscapeKeyListener = useEscapeKeyListener;
//# sourceMappingURL=useEscapeKeyListener.js.map
